<template>
  <div class="tw-border-y tw-border-neutral-300 tw-grid tw-grid-cols-12 tw-px-8 tw-divide-x tw-divide-neutral-300 -tw-mx-8">
    <slot />
  </div>
</template>
